<template>
    <div class="container" v-loading="loading">
        <div id="MAPRef" style="width: 100%;height: 100%;"></div>
		<div class="map_info">天地图 | 审图号：GS(2024)0568号 | <label @click="linkTo">湘ICP备2024068008号-1</label></div>
		<div class="info-box">
			<slot name="info" />
		</div>
		<div class="oper-box">
			<div class="oper-item" @click="backHome" alt="主页">
				<i class="icon-admin icon-admin-zhuye"></i>
			</div>
			<div class="oper-item" @click="resetAnimation" alt="主页">
				<i class="icon-admin icon-admin-refresh"></i>
			</div>
			<el-slider
				v-model="animationSpeed"
				:min="1"
				:max="5"
				vertical
				:show-tooltip="false"
				height="100px">
			</el-slider>
		</div>
    </div>
</template>
<script>
	import locationIcon from "@/static/icon/dic_local_point_v2.gif"
    export default{
		props: {
			linePoint: {
				type: Array,
				default: []
			},
			lineMarker: {
				type: Array,
				default: []
			},
		},
		watch: {
			linePoint: {
				handler(){
					this.$nextTick(() => {
						this.updatePolyline(this.linePoint)
					})
				},
				deep: true,
				immediate: false
			}
		},
        data(){
            return{
				loading: true,
                //天地图客户端KEY
                tdt_client_key: "d31ea8c8b73b25ec71206ebc27c0e389",
                mapRef: null,
                randerTypeKey: 'img_w',
				nowLocation: {
					latitude: 33.765432,
					longitude: 104.293175,
				},
				markerRef: [],
				trailLine: null,

				// 动画控制变量
				animationId: null,
				currentIndex: 0,
				isPlaying: true,
				animationSpeed: 3,
				passedWaypointsCount: 0,
				
				frameCounter: 0,
				framesPerStep: 10,  // 每步动画的帧数，控制平滑度
            }
        },
		// 在组件中使用
		computed: {
			isMobile() {
				return window.innerWidth < 768 // 根据实际需求定义断点
			}
		},
        methods: {
			linkTo(){
				window.open('https://beian.miit.gov.cn')
			},

			refresh(){
				this.activeCity = {
					label: '全国', value: ''
				}
				this.mapRef && this.mapRef.setView([ this.nowLocation.latitude, this.nowLocation.longitude ], 5);
				this.$emit('changeCity', this.activeCity)
				this.$emit('home')
			},
			
			checkPointIsMarker(currentIndex){
				const index = this.lineMarker.findIndex( item => item.location[0] === this.linePoint[currentIndex][0] && item.location[1] === this.linePoint[currentIndex][1] )
				return index > -1 ? this.lineMarker[index] : false
			},

			backHome(){
				this.$router.back()
			},

			// 重置动画
			resetAnimation() {
				// 停止当前动画
				if (this.animationId) {
					cancelAnimationFrame(this.animationId);
				}

				if(this.markerRef.length){
					this.markerRef.forEach( item => {
						this.mapRef && this.mapRef.removeLayer && this.mapRef.removeLayer(item);
					})
				}
				
				// 重置状态
				this.currentIndex = 0;
				this.passedWaypointsCount = 0;
				this.frameCounter = 0;
				this.currentProgress = 0;
				
				// 重置线条和标记
				this.trailLine.setLatLngs([]);
				
				// 重新开始动画
				this.isPlaying = true;
				this.animationId = requestAnimationFrame(this.animate);
			},

			// 初始化轨迹线
			initTrailLine() {
				this.trailLine = L.polyline([], {
					color: '#FFF',
					weight: 4,
					opacity: 0.8
				}).addTo(this.mapRef);
			},
			// 开始动画
			startAnimation() {
				this.animationId = requestAnimationFrame(this.animate);
			},
			// 动画函数
			animate() {
				// 控制动画速度
				this.frameCounter++;
				
				if (this.frameCounter % Math.floor( this.framesPerStep / this.animationSpeed ) !== 0) {
					this.animationId = requestAnimationFrame(this.animate);
					return;
				}
				// 检查是否是标记点 并创建标题
				if (this.checkPointIsMarker(this.currentIndex)) {
					this.createMarker(this.checkPointIsMarker(this.currentIndex))
				}

				// 检查是否到达终点
				if (this.currentIndex >= this.linePoint.length - 1) {
					this.isPlaying = false;
					return;
				}

				// 前进到下一个点
				this.currentIndex++;

				// 更新线条
				this.trailLine.setLatLngs(this.linePoint.slice(0, this.currentIndex + 1));
				
				// 更新进度
				this.currentProgress = Math.round(
					(this.currentIndex / (this.linePoint.length - 1)) * 100
				);
				
				// 继续动画
				if (this.isPlaying) {
					this.animationId = requestAnimationFrame(this.animate);
				}
			},

			createMarker(marker){
				const customIcon = L.icon({
					iconUrl: locationIcon,
					iconSize: [45, 45],
				});
				const markerRef = L.marker( marker.location, { icon: customIcon } ).addTo(this.mapRef);
				this.markerRef.push(markerRef)
				markerRef.addEventListener('click', () => {
					this.$emit("check", marker)
				})
				// 为标记绑定弹出窗口作为标题
				markerRef.bindTooltip(`
					<div style="text-align:center;">
						<div style="color: #208FF1;">${marker.name || '目标地点'}</div>
					</div>
				`, { 
					permanent: true,
					direction: 'right',
					className: 'custom-tooltip',
					offset: [10, -3]
				}).openTooltip();
			},
			
			updatePolyline(linePoint){
				const bounds = L.latLngBounds( linePoint );
      			this.mapRef.fitBounds( bounds,
					{ maxZoom: 18, minZoom: 5 }
				);
				this.initTrailLine()
				this.startAnimation()
			},

			setMapView(lat, lng){
				this.mapRef && this.mapRef.setView([ lat, lng ], 16);
			},
			getArrayDepth(arr){
				if (Array.isArray(arr)) {
					return 1 + Math.max(...arr.map(this.getArrayDepth));
				}
				return 0;
			},
			// 回显坐标翻转
			editLatlngRevers(coordinates){
				const arrayDepth = this.getArrayDepth(coordinates)
				if(arrayDepth == 2){
					return coordinates.map(item => {
					return item.map( cItem => {
						return [ cItem.lat, cItem.lng ]
					})
					})
				}else if(arrayDepth == 1 && coordinates.length > 1){
					return coordinates.map(item => [ item.lat, item.lng ])
				}else if(arrayDepth == 1 && coordinates.length <= 1){
					return coordinates.map(item => [ item.lat, item.lng ])
				}
			},
            // 挂载地图底图
			mountedBaseMap() {
				this.$nextTick(() => {
					const L = window.L
					if (!L) return
					let viewUrl = ''
					if (this.randerTypeKey == 'img_w') {
						viewUrl = "http://t4.tianditu.gov.cn/img_w/wmts?" +
							"SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
							"&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=" + this.tdt_client_key;
					} else {
						viewUrl = "http://t4.tianditu.gov.cn/vec_w/wmts?" +
							"SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
							"&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=" + this.tdt_client_key;
					}
					this.viewLayer = L.tileLayer(viewUrl, {
						maxNativeZoom: 18, // 超过图层最大值时的保持比例
						maxZoom: 22, // 允许缩放最大值
						preferCanvas: true,
						opacity: 1,
					}).addTo(this.mapRef);

					// 注记图层 默认添加
					const cvaURL = "http://t0.tianditu.gov.cn/cia_w/wmts?" +
						"SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
						"&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=" + this.tdt_client_key;
					this.cvaLayer = L.tileLayer(cvaURL, {
						maxNativeZoom: 18,
						maxZoom: 22,
						preferCanvas: true,
						opacity: 1,
					}).addTo(this.mapRef);
					this.loading = false
				})
			},
            // 地图初始化
			initTmap() {
				this.loading = true
				const L = window.L
				let lng = this.nowLocation.longitude;
				let lat = this.nowLocation.latitude;
				this.mapRef = L.map( 'MAPRef', {
					zoomControl: false, // 显示缩放控件
					attributionControl: false, // 显示版权文字
					zoomAnimation: false, // 禁用缩放动画
					markerZoomAnimation: false, // 禁用标记的缩放动画
					minZoom: 3,
				}).setView([lat, lng], this.isMobile ? 4 : 5);
				this.mountedBaseMap()
			},
        },
        mounted() {
			if (typeof window.L == 'function') {
				this.initTmap();
			} else {
				// 创建leaflet库
				const leafletScript = document.createElement('script');
				leafletScript.src = `https://unpkg.com/leaflet@1.9.4/dist/leaflet.js`;
				document.body.appendChild(leafletScript);
				leafletScript.onload = this.initTmap.bind(this);
			}
		}
    }
</script>
<style lang="scss" scoped>
	:deep(.mobile-tooltip){
		background: rgba($color: #FFF, $alpha: 0.8);
	}
	:deep(.custom-tooltip) {
		background: rgba($color: #FFF, $alpha: 0.9);
		padding: 3px 5px;
		font-size: 13px;
	}
	.container{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
		.info-box{
			position: absolute;
			left: 20px;top: 20px;
			z-index: 2000;
		}
		.oper-box{
			position: absolute;
			right: 20px;top: 20px;
			z-index: 2000;
			border-radius: 5px;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			align-items: center;
			.oper-item{
				background-color: rgba($color: #FFF, $alpha: 0.95);
				border-radius: 50px;
				width: 35px;height: 35px;
				cursor: pointer;
				text-align: center;
				line-height: 35px;
				margin-bottom: 20px;
			}
			.oper-item:hover{
				transform: scale(1.1);
			}
		}
	}
	@media (max-width: 767px) {
		.container{
			width: 100%;
			height: 100%;
			position: relative;
			overflow: hidden;
		}
	}
	.map_info{
		position: absolute;
		left: 0;bottom: 0;
		z-index: 924;
		width: 400px;
		background: rgba($color: #FFFFFF, $alpha: 0.8);
		font-size: 12px;
		padding: 6px 0;
		border-radius:  0 5px 0 0;
		text-align: center;
	}
	.map_info label{
		cursor: pointer;
	}
	.map_info label:hover{
		color: #0B57D0;
	}
	@media (max-width: 767px) {
		.map_info {
			width: 100%;
			border-radius: 0;
		}
	}
</style>